export interface ColleagueLike {
    email?: string;
}

export function matchColleagueByEmail<T extends ColleagueLike>(
    email: string | undefined | null,
    roster: readonly T[],
): T | undefined {
    const normalized = email?.trim().toLowerCase();
    if (!normalized) return undefined;
    return roster.find((user) => user.email?.trim().toLowerCase() === normalized);
}

export interface ContactActionTilesInput {
    isInternalContact: boolean;
    isChatEnabled: boolean;
    hasMatchedColleague: boolean;
    isRosterActive: boolean;
    isRosterSuccess: boolean;
    isRosterError: boolean;
    isRosterFetching: boolean;
}

export interface ContactActionTiles {
    showEmail: boolean;
    showChat: boolean;
}

export function resolveContactActionTiles(input: ContactActionTilesInput): ContactActionTiles {
    const {
        isInternalContact,
        isChatEnabled,
        hasMatchedColleague,
        isRosterActive,
        isRosterSuccess,
        isRosterError,
        isRosterFetching,
    } = input;

    const isRosterSettled = !isRosterActive || isRosterSuccess || isRosterError;

    const showChat = isInternalContact && isChatEnabled && hasMatchedColleague;
    const showEmail = !isInternalContact || (isRosterSettled && !isRosterFetching && !hasMatchedColleague);

    return {showEmail, showChat};
}
